/**
 * CartAnalyzeContainer
 * --
 */
import React from 'react';
import CartAnalyze from 'routes/admin.routes/admin.cart/CartAnalyze';
import { useUserStack } from 'store';

const CartAnalyzeContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <CartAnalyze
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default CartAnalyzeContainer;
